import type {
  TApiQueriesState,
  TQueryEntry,
} from '@/shared/redux/store/api-query-state.types';

const hasMatchingQuery = (
  apiState: TApiQueriesState | undefined,
  matches: (query: TQueryEntry) => boolean,
) =>
  Object.values(apiState?.queries ?? {}).some(
    (query) => query !== undefined && matches(query),
  );

const isPending = (query: TQueryEntry) => query.status === 'pending';

const isLoadingFirstData = (query: TQueryEntry) =>
  isPending(query) && query.data === undefined;

const isApiState = (value: unknown): value is TApiQueriesState =>
  typeof value === 'object' &&
  value !== null &&
  'queries' in value &&
  'config' in value;

export const selectApiStates = (state: object) =>
  Object.values(state).filter(isApiState);

export const isAnyQueryPending = (
  state: object,
  reducerPaths: readonly string[],
) =>
  reducerPaths.some((path) =>
    hasMatchingQuery(
      (state as Record<string, TApiQueriesState | undefined>)[path],
      isPending,
    ),
  );

export const isAnyQueryLoadingFirstData = (
  apiStates: readonly TApiQueriesState[],
) =>
  apiStates.some((apiState) => hasMatchingQuery(apiState, isLoadingFirstData));
